import styled from '@emotion/styled'
import { Input } from '@mui/material'

import circlesOrbitColorPalette from './circlesColorTheme'

export const SearchBarBox = styled('div')({
  border: `1px solid ${circlesOrbitColorPalette.neutrals[300]}`,
  borderRadius: 32,
  backgroundColor: '#fff',
  margin: 0,
  padding: `4px 16px`,
  width: '250px'
})

export const SearchBarInput = styled(Input)({
  border: 'none',
  outline: 'none',
  borderBottom: '0px',
  '&:focus-visible': {
    outline: '0px !important',
    borderBottom: '0px'
  },
  '&:focus': {
    outline: 'none',
    borderBottom: '0px'
  },
  '&:before': {
    borderBottom: '0px'
  },
  '&:after': {
    borderBottom: '0px'
  }
})
